import { DoorVisitReportStatus } from '../graphql/__generated__/graphql';
import type { DoorVisitReportRun } from './doorVisitReportApi';

export const isDoorVisitReportTerminal = (status: DoorVisitReportStatus): boolean =>
  status === DoorVisitReportStatus.Completed || status === DoorVisitReportStatus.Failed;

export const getDoorVisitReportStatusLabel = (
  report: Pick<DoorVisitReportRun, 'status' | 'totalRows'>,
): 'Queued' | 'Preparing total…' | 'Writing' | 'Failed' | 'Ready' => {
  switch (report.status) {
    case DoorVisitReportStatus.Queued:
      return 'Queued';
    case DoorVisitReportStatus.Running:
      return report.totalRows === '0' ? 'Preparing total…' : 'Writing';
    case DoorVisitReportStatus.Failed:
      return 'Failed';
    case DoorVisitReportStatus.Completed:
      return 'Ready';
  }
};

export const getDoorVisitReportStatusText = (report: Pick<DoorVisitReportRun, 'status' | 'processedRows' | 'totalRows'>): string =>
  getDoorVisitReportStatusLabel(report) === 'Writing'
    ? `Writing ${report.processedRows} of ${report.totalRows}`
    : getDoorVisitReportStatusLabel(report);

export const getDoorVisitReportProgressText = (
  report: Pick<DoorVisitReportRun, 'processedRows' | 'totalRows'>,
): string => `${report.processedRows} of ${report.totalRows}`;

export const getDoorVisitReportTerminalAnnouncement = (
  report: Pick<DoorVisitReportRun, 'status'>,
): string | null => {
  if (report.status === DoorVisitReportStatus.Completed) return 'Door Visit report is ready for download.';
  if (report.status === DoorVisitReportStatus.Failed) return 'Door Visit report failed.';
  return null;
};
